/**
 * `/$org/apps/probe/…`: Probe's area. The frame and the call are shared by
 * every page under it, so an interview keeps running while the person reads
 * the briefing or a past interview, and ends when they leave Probe.
 *
 * @module routes/$org.apps.probe
 */
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { AppsFrame } from "../components/apps/AppsFrame";
import { ProbeAreaProvider } from "../components/apps/probe/ProbeAreaProvider";

function ProbeAreaRouteView() {
  const { org: orgSegment } = Route.useParams();
  return (
    <AppsFrame>
      <ProbeAreaProvider orgSegment={orgSegment}>
        <div className="flex min-h-0 flex-1 flex-col" data-probe-area="">
          <Outlet />
        </div>
      </ProbeAreaProvider>
    </AppsFrame>
  );
}

export const Route = createFileRoute("/$org/apps/probe")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: ProbeAreaRouteView,
});
